/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Faq_ContactInputs */

const en_directory_ai_tools_faq_contact = /** @type {(inputs: Directory_Ai_Tools_Faq_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact us`)
};

const zh_directory_ai_tools_faq_contact = /** @type {(inputs: Directory_Ai_Tools_Faq_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系我们`)
};

/**
* | output |
* | --- |
* | "Contact us" |
*
* @param {Directory_Ai_Tools_Faq_ContactInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_faq_contact = /** @type {((inputs?: Directory_Ai_Tools_Faq_ContactInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Faq_ContactInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_faq_contact(inputs)
	return zh_directory_ai_tools_faq_contact(inputs)
});
export { directory_ai_tools_faq_contact as "directory.ai_tools.faq_contact" }